/**
 * Country-specific content mappings
 * Provides localized content for different countries
 */

export const COUNTRY_CONTENT = {
  SG: {
    // Country info
    countryName: 'Singapore',
    countryCode: 'SG',
    currency: 'SGD',
    
    // Business terms
    businessType: 'SMEs',
    businessTypeFull: 'Small and Medium Enterprises',
    
    // Grant-specific terms
    grantType: 'grants and funding programmes',
    grantTypeFull: 'local grants and funding programmes',
    grantExamples: 'EDGE, SFEC, EEG, ECI',
    grantExamplesFull: 'EDGE, SFEC, EEG, ECI, legacy EDG/PSG/MRA claims, and other public and private funding schemes',
    
    // Content strings
    seoDescription: "AI-powered funding advisor helping businesses discover, evaluate, and secure relevant funding",
    offerDescription: "AI-powered grant application tools for Singapore SMEs",
    
    freeTierDescription: "Try OPTRA's core features at no cost. No credit card required. Get instant access to Ask OPTRA for unlimited grant questions and use our Eligibility Checker to discover which grants and funding opportunities your business qualifies for. Start exploring your grant opportunities today with full access to our AI-powered tools.",
    
    askOptraDescription: "Get instant answers on eligibility, funding, timelines, and documents. Our AI uses the latest official grant information for accurate, cited guidance on EDGE, SFEC, ECI, legacy EDG/PSG/MRA claims and more.",
    
    eligibilityCheckerDescription: "Find which grants and funding opportunities you qualify for in minutes. We match your profile and project to official criteria and deliver scores, recommendations, and next steps—including funding ranges and timelines.",
    
    whyChooseSubtitle: "Built for Singapore SMEs who need clarity, speed, and confidence",
    
    builtForGrantsTitle: "Built for Singapore Grants",
    builtForGrantsDescription: "OPTRA is designed around EDGE, SFEC, ECI, EEG and legacy EnterpriseSG claim workflows, so recommendations align with how Singapore funding is actually assessed — not generic, overseas templates.",
    
    // JSON-LD data
    jsonLd: {
      addressCountry: "SG",
      addressLocality: "Singapore",
      linkedInUrl: "https://sg.linkedin.com/company/optra-labs"
    }
  },
  
  MY: {
    // Country info
    countryName: 'Malaysia',
    countryCode: 'MY',
    currency: 'MYR',
    
    // Business terms
    businessType: 'SMEs',
    businessTypeFull: 'Small and Medium Enterprises',
    
    // Grant-specific terms
    grantType: 'grants and funding programmes',
    grantTypeFull: 'local grants and funding programmes',
    grantExamples: 'MDEC, MATRADE, Cradle, MAVCAP',
    grantExamplesFull: 'MDEC, MATRADE, Cradle, MAVCAP, and other public and private funding schemes',
    
    // Content strings
    seoDescription: "AI-powered funding advisor helping businesses discover, evaluate, and secure relevant funding",
    offerDescription: "AI-powered grant application tools for Malaysian SMEs",
    
    freeTierDescription: "Try OPTRA's core features at no cost. No credit card required. Get instant access to Ask OPTRA for unlimited grant questions and use our Eligibility Checker to discover which grants and funding opportunities your business qualifies for. Start exploring your grant opportunities today with full access to our AI-powered tools.",
    
    askOptraDescription: "Get instant answers on eligibility, funding, timelines, and documents. Our AI uses the latest official grant information for accurate, cited guidance on MDEC, MATRADE, Cradle, MAVCAP and more.",
    
    eligibilityCheckerDescription: "Find which grants and funding opportunities you qualify for in minutes. We match your profile and project to official criteria and deliver scores, recommendations, and next steps—including funding ranges and timelines.",
    
    whyChooseSubtitle: "Built for Malaysian businesses who need clarity, speed, and confidence",
    
    builtForGrantsTitle: "Built for Malaysian Grants",
    builtForGrantsDescription: "OPTRA is designed around MDEC, MATRADE, Cradle, MAVCAP and other Malaysian grant schemes, so recommendations align with how local grants are actually assessed — not generic, overseas templates.",
    
    // JSON-LD data
    jsonLd: {
      addressCountry: "MY",
      addressLocality: "Malaysia",
      linkedInUrl: "https://www.linkedin.com/company/optra-labs"
    }
  },
  
  ID: {
    // Country info
    countryName: 'Indonesia',
    countryCode: 'ID',
    currency: 'IDR',
    
    // Business terms
    businessType: 'UMKM',
    businessTypeFull: 'Usaha Mikro, Kecil, dan Menengah',
    
    // Grant-specific terms
    grantType: 'grants and funding programmes',
    grantTypeFull: 'local grants and funding programmes',
    grantExamples: 'BKPM, Kemenristek, Kemenparekraf, Kemenkop UKM',
    grantExamplesFull: 'BKPM, Kemenristek, Kemenparekraf, Kemenkop UKM, and other public and private funding schemes',
    
    // Content strings
    seoDescription: "AI-powered funding advisor helping businesses discover, evaluate, and secure relevant funding",
    offerDescription: "AI-powered grant application tools for Indonesian UMKM",
    
    freeTierDescription: "Try OPTRA's core features at no cost. No credit card required. Get instant access to Ask OPTRA for unlimited grant questions and use our Eligibility Checker to discover which grants and funding opportunities your business qualifies for. Start exploring your grant opportunities today with full access to our AI-powered tools.",
    
    askOptraDescription: "Get instant answers on eligibility, funding, timelines, and documents. Our AI uses the latest official grant information for accurate, cited guidance on BKPM, Kemenristek, Kemenparekraf, Kemenkop UKM and more.",
    
    eligibilityCheckerDescription: "Find which grants and funding opportunities you qualify for in minutes. We match your profile and project to official criteria and deliver scores, recommendations, and next steps—including funding ranges and timelines.",
    
    whyChooseSubtitle: "Built for Indonesian businesses who need clarity, speed, and confidence",
    
    builtForGrantsTitle: "Built for Indonesian Grants",
    builtForGrantsDescription: "OPTRA is designed around BKPM, Kemenristek, Kemenparekraf, Kemenkop UKM and other Indonesian grant schemes, so recommendations align with how local grants are actually assessed — not generic, overseas templates.",
    
    // JSON-LD data
    jsonLd: {
      addressCountry: "ID",
      addressLocality: "Indonesia",
      linkedInUrl: "https://www.linkedin.com/company/optra-labs"
    }
  },
  
  TH: {
    // Country info
    countryName: 'Thailand',
    countryCode: 'TH',
    currency: 'THB',
    
    // Business terms
    businessType: 'SMEs',
    businessTypeFull: 'Small and Medium Enterprises',
    
    // Grant-specific terms
    grantType: 'grants and funding programmes',
    grantTypeFull: 'local grants and funding programmes',
    grantExamples: 'BOI, NSTDA, DIP, SME Bank',
    grantExamplesFull: 'BOI, NSTDA, DIP, SME Bank, and other public and private funding schemes',
    
    // Content strings
    seoDescription: "AI-powered funding advisor helping businesses discover, evaluate, and secure relevant funding",
    offerDescription: "AI-powered grant application tools for Thai SMEs",
    
    freeTierDescription: "Try OPTRA's core features at no cost. No credit card required. Get instant access to Ask OPTRA for unlimited grant questions and use our Eligibility Checker to discover which grants and funding opportunities your business qualifies for. Start exploring your grant opportunities today with full access to our AI-powered tools.",
    
    askOptraDescription: "Get instant answers on eligibility, funding, timelines, and documents. Our AI uses the latest official grant information for accurate, cited guidance on BOI, NSTDA, DIP, SME Bank and more.",
    
    eligibilityCheckerDescription: "Find which grants and funding opportunities you qualify for in minutes. We match your profile and project to official criteria and deliver scores, recommendations, and next steps—including funding ranges and timelines.",
    
    whyChooseSubtitle: "Built for Thai businesses who need clarity, speed, and confidence",
    
    builtForGrantsTitle: "Built for Thai Grants",
    builtForGrantsDescription: "OPTRA is designed around BOI, NSTDA, DIP, SME Bank and other Thai grant schemes, so recommendations align with how local grants are actually assessed — not generic, overseas templates.",
    
    // JSON-LD data
    jsonLd: {
      addressCountry: "TH",
      addressLocality: "Thailand",
      linkedInUrl: "https://www.linkedin.com/company/optra-labs"
    }
  },
  
  VN: {
    // Country info
    countryName: 'Vietnam',
    countryCode: 'VN',
    currency: 'VND',
    
    // Business terms
    businessType: 'SMEs',
    businessTypeFull: 'Small and Medium Enterprises',
    
    // Grant-specific terms
    grantType: 'grants and funding programmes',
    grantTypeFull: 'local grants and funding programmes',
    grantExamples: 'MOST, MOIT, VCCI, SMEDF',
    grantExamplesFull: 'MOST, MOIT, VCCI, SMEDF, and other public and private funding schemes',
    
    // Content strings
    seoDescription: "AI-powered funding advisor helping businesses discover, evaluate, and secure relevant funding",
    offerDescription: "AI-powered grant application tools for Vietnamese SMEs",
    
    freeTierDescription: "Try OPTRA's core features at no cost. No credit card required. Get instant access to Ask OPTRA for unlimited grant questions and use our Eligibility Checker to discover which grants and funding opportunities your business qualifies for. Start exploring your grant opportunities today with full access to our AI-powered tools.",
    
    askOptraDescription: "Get instant answers on eligibility, funding, timelines, and documents. Our AI uses the latest official grant information for accurate, cited guidance on MOST, MOIT, VCCI, SMEDF and more.",
    
    eligibilityCheckerDescription: "Find which grants and funding opportunities you qualify for in minutes. We match your profile and project to official criteria and deliver scores, recommendations, and next steps—including funding ranges and timelines.",
    
    whyChooseSubtitle: "Built for Vietnamese businesses who need clarity, speed, and confidence",
    
    builtForGrantsTitle: "Built for Vietnamese Grants",
    builtForGrantsDescription: "OPTRA is designed around MOST, MOIT, VCCI, SMEDF and other Vietnamese grant schemes, so recommendations align with how local grants are actually assessed — not generic, overseas templates.",
    
    // JSON-LD data
    jsonLd: {
      addressCountry: "VN",
      addressLocality: "Vietnam",
      linkedInUrl: "https://www.linkedin.com/company/optra-labs"
    }
  },
  
  PH: {
    // Country info
    countryName: 'Philippines',
    countryCode: 'PH',
    currency: 'PHP',
    
    // Business terms
    businessType: 'MSMEs',
    businessTypeFull: 'Micro, Small and Medium Enterprises',
    
    // Grant-specific terms
    grantType: 'grants and funding programmes',
    grantTypeFull: 'local grants and funding programmes',
    grantExamples: 'DTI, DOST, BOI, PCCI',
    grantExamplesFull: 'DTI, DOST, BOI, PCCI, and other public and private funding schemes',
    
    // Content strings
    seoDescription: "AI-powered funding advisor helping businesses discover, evaluate, and secure relevant funding",
    offerDescription: "AI-powered grant application tools for Philippine MSMEs",
    
    freeTierDescription: "Try OPTRA's core features at no cost. No credit card required. Get instant access to Ask OPTRA for unlimited grant questions and use our Eligibility Checker to discover which grants and funding opportunities your business qualifies for. Start exploring your grant opportunities today with full access to our AI-powered tools.",
    
    askOptraDescription: "Get instant answers on eligibility, funding, timelines, and documents. Our AI uses the latest official grant information for accurate, cited guidance on DTI, DOST, BOI, PCCI and more.",
    
    eligibilityCheckerDescription: "Find which grants and funding opportunities you qualify for in minutes. We match your profile and project to official criteria and deliver scores, recommendations, and next steps—including funding ranges and timelines.",
    
    whyChooseSubtitle: "Built for Philippine businesses who need clarity, speed, and confidence",
    
    builtForGrantsTitle: "Built for Philippine Grants",
    builtForGrantsDescription: "OPTRA is designed around DTI, DOST, BOI, PCCI and other Philippine grant schemes, so recommendations align with how local grants are actually assessed — not generic, overseas templates.",
    
    // JSON-LD data
    jsonLd: {
      addressCountry: "PH",
      addressLocality: "Philippines",
      linkedInUrl: "https://www.linkedin.com/company/optra-labs"
    }
  },
  
  BN: {
    countryName: 'Brunei',
    countryCode: 'BN',
    currency: 'BND',
    businessType: 'SMEs',
    businessTypeFull: 'Small and Medium Enterprises',
    grantType: 'grants and funding programmes',
    grantTypeFull: 'local grants and funding programmes',
    grantExamples: 'BEDB, DARe, MOFE',
    grantExamplesFull: 'BEDB, DARe, MOFE, and other public and private funding schemes',
    seoDescription: "AI-powered funding advisor helping businesses discover, evaluate, and secure relevant funding",
    offerDescription: "AI-powered grant application tools for Brunei SMEs",
    freeTierDescription: "Try OPTRA's core features at no cost. No credit card required. Get instant access to Ask OPTRA for unlimited grant questions and use our Eligibility Checker to discover which grants and funding opportunities your business qualifies for. Start exploring your grant opportunities today with full access to our AI-powered tools.",
    askOptraDescription: "Get instant answers on eligibility, funding, timelines, and documents. Our AI uses the latest official grant information for accurate, cited guidance on BEDB, DARe, MOFE and more.",
    eligibilityCheckerDescription: "Find which grants and funding opportunities you qualify for in minutes. We match your profile and project to official criteria and deliver scores, recommendations, and next steps—including funding ranges and timelines.",
    whyChooseSubtitle: "Built for Brunei businesses who need clarity, speed, and confidence",
    builtForGrantsTitle: "Built for Brunei Grants",
    builtForGrantsDescription: "OPTRA is designed around BEDB, DARe, MOFE and other Brunei grant schemes, so recommendations align with how local grants are actually assessed.",
    jsonLd: {
      addressCountry: "BN",
      addressLocality: "Brunei",
      linkedInUrl: "https://www.linkedin.com/company/optra-labs"
    }
  },
  
  KH: {
    countryName: 'Cambodia',
    countryCode: 'KH',
    currency: 'KHR',
    businessType: 'SMEs',
    businessTypeFull: 'Small and Medium Enterprises',
    grantType: 'grants and funding programmes',
    grantTypeFull: 'local grants and funding programmes',
    grantExamples: 'CDC, MISTI, MAFF',
    grantExamplesFull: 'CDC, MISTI, MAFF, and other public and private funding schemes',
    seoDescription: "AI-powered funding advisor helping businesses discover, evaluate, and secure relevant funding",
    offerDescription: "AI-powered grant application tools for Cambodian SMEs",
    freeTierDescription: "Try OPTRA's core features at no cost. No credit card required. Get instant access to Ask OPTRA for unlimited grant questions and use our Eligibility Checker to discover which grants and funding opportunities your business qualifies for. Start exploring your grant opportunities today with full access to our AI-powered tools.",
    askOptraDescription: "Get instant answers on eligibility, funding, timelines, and documents. Our AI uses the latest official grant information for accurate, cited guidance on CDC, MISTI, MAFF and more.",
    eligibilityCheckerDescription: "Find which grants and funding opportunities you qualify for in minutes. We match your profile and project to official criteria and deliver scores, recommendations, and next steps—including funding ranges and timelines.",
    whyChooseSubtitle: "Built for Cambodian businesses who need clarity, speed, and confidence",
    builtForGrantsTitle: "Built for Cambodian Grants",
    builtForGrantsDescription: "OPTRA is designed around CDC, MISTI, MAFF and other Cambodian grant schemes, so recommendations align with how local grants are actually assessed.",
    jsonLd: {
      addressCountry: "KH",
      addressLocality: "Cambodia",
      linkedInUrl: "https://www.linkedin.com/company/optra-labs"
    }
  },
  
  LA: {
    countryName: 'Laos',
    countryCode: 'LA',
    currency: 'LAK',
    businessType: 'SMEs',
    businessTypeFull: 'Small and Medium Enterprises',
    grantType: 'grants and funding programmes',
    grantTypeFull: 'local grants and funding programmes',
    grantExamples: 'MPI, MOIC, BOL',
    grantExamplesFull: 'MPI, MOIC, BOL, and other public and private funding schemes',
    seoDescription: "AI-powered funding advisor helping businesses discover, evaluate, and secure relevant funding",
    offerDescription: "AI-powered grant application tools for Lao SMEs",
    freeTierDescription: "Try OPTRA's core features at no cost. No credit card required. Get instant access to Ask OPTRA for unlimited grant questions and use our Eligibility Checker to discover which grants and funding opportunities your business qualifies for. Start exploring your grant opportunities today with full access to our AI-powered tools.",
    askOptraDescription: "Get instant answers on eligibility, funding, timelines, and documents. Our AI uses the latest official grant information for accurate, cited guidance on MPI, MOIC, BOL and more.",
    eligibilityCheckerDescription: "Find which grants and funding opportunities you qualify for in minutes. We match your profile and project to official criteria and deliver scores, recommendations, and next steps—including funding ranges and timelines.",
    whyChooseSubtitle: "Built for Lao businesses who need clarity, speed, and confidence",
    builtForGrantsTitle: "Built for Lao Grants",
    builtForGrantsDescription: "OPTRA is designed around MPI, MOIC, BOL and other Lao grant schemes, so recommendations align with how local grants are actually assessed.",
    jsonLd: {
      addressCountry: "LA",
      addressLocality: "Laos",
      linkedInUrl: "https://www.linkedin.com/company/optra-labs"
    }
  },
  
  MM: {
    countryName: 'Myanmar',
    countryCode: 'MM',
    currency: 'MMK',
    businessType: 'SMEs',
    businessTypeFull: 'Small and Medium Enterprises',
    grantType: 'grants and funding programmes',
    grantTypeFull: 'local grants and funding programmes',
    grantExamples: 'MOPF, MOEE, DICA',
    grantExamplesFull: 'MOPF, MOEE, DICA, and other public and private funding schemes',
    seoDescription: "AI-powered funding advisor helping businesses discover, evaluate, and secure relevant funding",
    offerDescription: "AI-powered grant application tools for Myanmar SMEs",
    freeTierDescription: "Try OPTRA's core features at no cost. No credit card required. Get instant access to Ask OPTRA for unlimited grant questions and use our Eligibility Checker to discover which grants and funding opportunities your business qualifies for. Start exploring your grant opportunities today with full access to our AI-powered tools.",
    askOptraDescription: "Get instant answers on eligibility, funding, timelines, and documents. Our AI uses the latest official grant information for accurate, cited guidance on MOPF, MOEE, DICA and more.",
    eligibilityCheckerDescription: "Find which grants and funding opportunities you qualify for in minutes. We match your profile and project to official criteria and deliver scores, recommendations, and next steps—including funding ranges and timelines.",
    whyChooseSubtitle: "Built for Myanmar businesses who need clarity, speed, and confidence",
    builtForGrantsTitle: "Built for Myanmar Grants",
    builtForGrantsDescription: "OPTRA is designed around MOPF, MOEE, DICA and other Myanmar grant schemes, so recommendations align with how local grants are actually assessed.",
    jsonLd: {
      addressCountry: "MM",
      addressLocality: "Myanmar",
      linkedInUrl: "https://www.linkedin.com/company/optra-labs"
    }
  },

  // OPTRA US (/us): the same services as Singapore, for U.S. businesses, so this entry mirrors the
  // SG entry with the country swapped. Program names come from the U.S. research docs; see
  // src/regions/us/CONTENT_REVIEW.md. The homepage's own copy lives in ./homeContent.js.
  // OPTRA Labs is a Singapore company, so the JSON-LD address stays Singapore: no U.S. office is claimed.
  US: {
    countryName: 'United States',
    countryCode: 'US',
    currency: 'USD',
    businessType: 'small businesses',
    businessTypeFull: 'small and medium-sized businesses',
    grantType: 'grants and funding programs',
    grantTypeFull: 'federal and state grants and funding programs',
    grantExamples: 'SBIR, STTR',
    grantExamplesFull: 'SBIR, STTR, and other federal and state funding programs',
    seoDescription: "AI-powered funding advisor helping businesses discover, evaluate, and secure relevant funding",
    offerDescription: "AI-powered grant application tools for U.S. small businesses",
    freeTierDescription: "Try OPTRA's core features at no cost. No credit card required. Get instant access to Ask OPTRA for unlimited grant questions and use our Eligibility Checker to discover which grants and funding opportunities your business qualifies for. Start exploring your grant opportunities today with full access to our AI-powered tools.",
    askOptraDescription: "Get instant answers on eligibility, funding, timelines, and documents. Our AI uses the latest official grant information for accurate, cited guidance on SBIR, STTR and more.",
    eligibilityCheckerDescription: "Find which grants and funding opportunities you qualify for in minutes. We match your profile and project to official criteria and deliver scores, recommendations, and next steps—including funding ranges and timelines.",
    whyChooseSubtitle: "Built for U.S. small businesses who need clarity, speed, and confidence",
    builtForGrantsTitle: "Built for U.S. Grants",
    builtForGrantsDescription: "OPTRA is designed around SBIR, STTR and other U.S. federal and state funding programs, so recommendations align with how local grants are actually assessed — not generic, overseas templates.",
    jsonLd: {
      addressCountry: "SG",
      addressLocality: "Singapore",
      linkedInUrl: "https://www.linkedin.com/company/optra-labs"
    }
  }
};

/**
 * Get country-specific content
 * @param {string} countryCode - Country code (e.g., 'SG', 'US')
 * @returns {Object} Country-specific content object
 */
export const getCountryContent = (countryCode = 'SG') => {
  return COUNTRY_CONTENT[countryCode] || COUNTRY_CONTENT['SG'];
};

export default COUNTRY_CONTENT;
